import FontFaceObserver from 'fontfaceobserver';

/**
 * Observes specified web fonts and adds a 'fonts-loaded' class to the HTML element upon completion.
 * @param {Array} selfHostedFonts - Array of self-hosted font objects to observe.
 *                                  Each object: { family: string, weight?: string, style?: string }
 * @param {Array} adobeFonts - Array of Adobe font objects to observe.
 *                             Each object: { family: string, weight?: string, style?: string }
 */
export function loadWebFonts(selfHostedFonts = [], adobeFonts = []) {
  const observers = [];

  selfHostedFonts.forEach(font => {
    const observer = new FontFaceObserver(font.family, {
      weight: font.weight,
      style: font.style,
      // stretch: font.stretch // Uncomment if you use font-stretch
    });
    observers.push(observer.load(null, 5000)); // 5000ms timeout per font
  });

  adobeFonts.forEach(font => {
    const adobeObserver = new FontFaceObserver(font.family, {
      weight: font.weight,
      style: font.style,
    });
    observers.push(adobeObserver.load(null, 5000)); // 5000ms timeout per font
  });

  if (observers.length === 0) {
    console.info('Web Fonts: No fonts configured for observation. Skipping.');
    // If no fonts are configured, you might want to add 'fonts-loaded' immediately
    // or handle this case as per your project's requirements.
    // document.documentElement.classList.add('fonts-loaded');
    return Promise.resolve();
  }

  console.log('Web Fonts: Observing configured fonts...');

  return Promise.all(observers.map(p => p.catch(e => e))) // Continue if some fonts fail
    .then((results) => {
      document.documentElement.classList.add('fonts-loaded');
      console.log('Web Fonts: Font observation complete. Class "fonts-loaded" added to <html>.');

      results.forEach(result => {
        if (result instanceof Error) { // FontFaceObserver load promise rejects with an Error object on failure
          console.warn(`Web Fonts: Font "${result.message.split('"')[1]}" failed to load or timed out.`);
        }
      });

      // Dispatch a custom event if other modules need to react to fonts loaded
      document.dispatchEvent(new CustomEvent('webfontsloaded', { detail: results }));
    })
    .catch((err) => {
      // This catch is for Promise.all itself, though individual errors are handled above.
      console.error('Web Fonts: A critical error occurred during font observation.', err);
      // Fallback: still add fonts-loaded or a specific error class like 'fonts-failed'
      // document.documentElement.classList.add('fonts-failed');
    });
}